(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfValidateSave', [
    '$compile', function($compile) {
      return {
        restrict: 'A',
        require: ['^mfValidate'],
        scope: {
          mfValidateSave: '=',
          alwaysReenable: '='
        },
        link: function($scope, element, attrs, ctrl) {
          var mfValidate, params;
          mfValidate = ctrl[0];
          params = [].concat($scope.mfValidateSave);
          return element.on('click', function() {
            var ref;
            element.prop('disabled', true);
            return (ref = mfValidate.save(true, params)) != null ? typeof ref.then === "function" ? ref.then(function(result) {
              var ref1, ref2;
              if ($scope.alwaysReenable || (result == null) || (result != null ? (ref1 = result.data) != null ? (ref2 = ref1.status) != null ? ref2.type : void 0 : void 0 : void 0) === 'error') {
                return element.prop('disabled', false);
              }
            }, function() {
              return element.prop('disabled', false);
            }) : void 0 : void 0;
          });
        }
      };
    }
  ]);

}).call(this);
